export const USER_LIST_INITIAL = [];
export const TYPE_LIST_INITIAL = [];
export const INNER_NOTIFICATION_INITIAL = [];
export const ALL_CUSTOMER_INITIAL = [];
export const ALL_PROJECT_INITIAL = [];
export const ALL_STATE_INITIAL = [];
export const PER_DIEM_INITIAL = [];
export const OFFSET_INITIAL = 0;
export const SORT_INITIAL = { order: "", orderBy: "" };
export const ACTIVE_USER_INITIAL = {
  isActive: true,
  userId: null,
};
export const CHECK_USER_INITIAL = {};
export const STATEMENT_INITIAL = {
  customerStatus: "",
  projectStatus: "",
  userId: "",
  projectId: "",
};
export const ADMIN_STATEMENT_INITIAL = {
  customerStatus: "",
  projectStatus: "",
  userId: "",
  projectId: "",
};
export const INVOICE_LIST_INITIAL = {
  customerStatus: "",
  projectStatus: "",
  userId: "",
  projectId: "",
};
export const CUSTOMER_FILTER_INITIAL = {
  customerStatusActive: "",
  customerStatus: "",
  customer: [],
  billingDefaultDayRate: "",
  billingDefaultperiod: "",
};

export const CONSOLIDATE_INVOICE_LIST_INITIAL = {
  matchedData: [],
  userList: [],
};
